var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Highlight } from "../highlight/Highlight";
import { RenderContainer } from "@skbkontur/react-ui/internal/RenderContainer";
import { addListener } from "@skbkontur/react-ui/lib/LayoutEvents";
var initialRect = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
};
var TooltipHighlight = /** @class */ (function (_super) {
    __extends(TooltipHighlight, _super);
    function TooltipHighlight() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { pos: initialRect, hasElem: true };
        _this.reflow = function () {
            if (_this.target) {
                var pos = _this.target.getBoundingClientRect();
                _this.setState({ pos: pos });
            }
        };
        return _this;
    }
    TooltipHighlight.prototype.componentWillMount = function () {
        if (!this.props.anchorElement()) {
            this.setState({ hasElem: false });
        }
    };
    TooltipHighlight.prototype.render = function () {
        return (React.createElement("div", null,
            this.props.children,
            this.state.hasElem && (React.createElement(RenderContainer, null,
                React.createElement(Highlight, { pos: this.state.pos, highlight: this.props.highlight })))));
    };
    TooltipHighlight.prototype.componentDidMount = function () {
        if (!this.state.hasElem)
            return;
        this.target = this.props.anchorElement();
        this.reflow();
        //add throttle
        this._layoutEventsToken = addListener(this.reflow);
    };
    TooltipHighlight.prototype.componentWillReceiveProps = function () {
        if (this.target) {
            requestAnimationFrame(this.reflow.bind(this));
        }
    };
    TooltipHighlight.prototype.componentWillUnmount = function () {
        this._layoutEventsToken && this._layoutEventsToken.remove();
    };
    return TooltipHighlight;
}(React.Component));
export { TooltipHighlight };
